import { Box } from "@chakra-ui/layout"
import { AppEntityHydrated } from "@jackfruit/common"
import React from "react"
import HeaderBlock from "../../../components/blocks/HeaderBlock"

interface Props {
  config: AppEntityHydrated
}

const Header: React.FC<Props> = ({ config }) => {
  const pageWithHeader = config.pages.find(page =>
    page.blocks.some(block => block.type === "header")
  )

  const headerBlock = pageWithHeader?.blocks.find(
    block => block.type === "header"
  )

  if (!headerBlock) {
    return null
  }

  const headerConfig = config.blockHeaders.find(
    header => Number(header.id) === Number(headerBlock.headerId)
  )

  if (!headerConfig) {
    return null
  }

  return (
    <Box className="block-header">
      <HeaderBlock
        config={headerConfig}
        pages={config.pages}
        appConfig={config}
      />
    </Box>
  )
}

export default Header
